import React from 'react';
import { motion } from 'motion/react';
import { Rss } from 'lucide-react';

const footerLinks = [
  {
    label: 'Cloud Feeds',
    links: [
      { title: 'AWS What\'s New', href: 'https://aws.amazon.com/about-aws/whats-new/' },
      { title: 'Google Cloud Blog', href: 'https://cloud.google.com/blog' },
      { title: 'Azure Blog', href: 'https://azure.microsoft.com/en-us/blog/' },
    ],
  },
  {
    label: 'Documentation',
    links: [
      { title: 'AWS Docs', href: 'https://docs.aws.amazon.com' },
      { title: 'GCP Docs', href: 'https://cloud.google.com/docs' },
      { title: 'Azure Docs', href: 'https://learn.microsoft.com/azure' },
      { title: 'Cloud Compare', href: 'https://cloudprice.net' },
    ],
  },
];

export function Footer() {
  return (
    <footer className="relative w-full max-w-6xl mx-auto rounded-t-[2rem] md:rounded-t-[3rem] border-t border-white/10 bg-[radial-gradient(35%_128px_at_50%_0%,rgba(255,255,255,0.04),transparent)] px-8 py-10 lg:py-12">
      <div className="absolute top-0 right-1/2 left-1/2 h-px w-1/3 -translate-x-1/2 -translate-y-px rounded-full bg-white/20 blur-sm" />

      {/* Link columns */}
      <AnimatedContainer>
        <div className="flex gap-16">
          {footerLinks.map((section) => (
            <div key={section.label}>
              <h3 className="text-white/60 text-xs font-semibold uppercase tracking-widest mb-4">
                {section.label}
              </h3>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.title}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/35 hover:text-white/70 text-sm transition-colors duration-200"
                    >
                      {link.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </AnimatedContainer>

      {/* Attribution */}
      <AnimatedContainer delay={0.15} className="mt-10 pt-6 border-t border-white/8 flex items-center gap-2">
        <Rss className="size-3.5 text-white/20" />
        <p className="text-white/30 text-xs">
          Engineered by{' '}
          <a
              href="https://www.linkedin.com/in/tankaijian"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/55 font-medium hover:text-white/80 transition-colors duration-200"
            >Kai Jian</a>
          {' '}· © {new Date().getFullYear()}
        </p>
      </AnimatedContainer>
    </footer>
  );
}

function AnimatedContainer({ className, delay = 0.05, children }) {
  return (
    <motion.div
      initial={{ filter: 'blur(4px)', translateY: -6, opacity: 0 }}
      whileInView={{ filter: 'blur(0px)', translateY: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ delay, duration: 0.6 }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
